module.exports = __webpack_public_path__ + "img/tripadvisor.7a31ab85.svg";